import {erNil} from "../støttefunksjoner/nilsjekk";
import {nil} from "felles-ng2/typer/nullish";
import {leggTilListeDersomIkkeInkludert} from "felles-ng2/støttefunksjoner/lister";
import {MedId} from "felles-ng2/tjenester/datalager/datatjeneste";
import {EntitetId} from "felles-ng2/tjenester/ressurser/ng2HttpKlientTilleggstyper";

/** Filter-funksjon som filtrerer bort entiteter som IKKE har angitt `id`.
 * Eks: [entitetA, entitetB].filter(harId(idX)) */
export function harId<E extends MedId>(id: EntitetId): (entitet:E) => boolean {
    return entitet => entitet.id === id;
}

export function harSammeId(a: MedId | nil, b: MedId | nil): boolean {
    if (erNil(a) || erNil(b)) return false;
    return a?.id === b?.id;
}

/** Filter-funksjon som filtrerer bort entiteter som IKKE har samme id som angitt `annen`.
 * Eks: [entitetA, entitetB].filter(ikkeSammeIdSom(entitetX)) */
export function sammeIdSom<E extends MedId>(annen: MedId): (entitet:E) => boolean {
    return entitet => harSammeId(entitet, annen);
}

/** Filter-funksjon som filtrerer bort entiteter som har samme id som angitt `annen`.
 * Eks: [entitetA, entitetB].filter(ikkeSammeIdSom(entitetX)) */
export function ikkeSammeIdSom<E extends MedId>(annen: MedId): (entitet:E) => boolean {
    return entitet => !harSammeId(entitet, annen);
}

export function somEntitetId<ID extends EntitetId>(entitet: MedId<ID>): ID {
    return entitet.id;
}

export function inneholderEntitetBasertPåId<E extends MedId>(entiteter:E[], kandidat: E):boolean {
    return entiteter.some(entitet => entitet.id == kandidat.id);
}

/** Returnerer kopi av angitt 'entiteter' der angitt 'potensieltNy' er lagt til på slutten dersom entitet ikke allerede finnes i entiteter. */
export function leggEntitetTilListeDersomIkkeInkludert<T extends MedId>(potensieltNy: T | nil, entiteter: T[]): T[] {
    return leggTilListeDersomIkkeInkludert(potensieltNy, entiteter, (a, b) => harSammeId(a, b));
}

/** Returnerer kopi av angitt 'entiteter' der angitte 'potensieltNye' er lagt til på slutten dersom de ikke allerede finnes i entiteter. */
export function leggEntiteterTilListeDersomIkkeInkludert<T extends MedId>(potensieltNye: T[], entiteter: T[]): T[] {
    return [
        ...entiteter,
        ...potensieltNye.filter(ny => !entiteter.some(eksisterende => eksisterende.id == ny.id))];
}
